const { apiFetch } = wp;

const newslettersApi = {
  /**
   * Fetch subscriber details.
   *
   * @param {String} email Subscriber email
   * @returns {Promise}
   */
  fetchNewsletters() {
    return apiFetch({
      path: '/nbc/v1/newsletters',
    });
  },
};

export default newslettersApi;
